// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"81":"vcard","594":"about","671":"services","912":"contacts","946":"news"}[chunkId] + "." + {"81":"81e09607","594":"9ddcf240","671":"8a62a711","912":"8f29549f","946":"6590f8fa"}[chunkId] + ".js";
};